import { render as wpElementRenderer } from '@wordpress/element';
import { TimePicker } from '@wordpress/components';
import jQuery from 'jquery';

jQuery(document).ready(function($) {

	$( '#bookings_availability, #bookings_pricing, .bookings_extension' ).on( 'change', '.wc_booking_availability_type select, .wc_booking_pricing_type select', function() {
		var value = $(this).val();
		var tr    = $(this).closest('tr')
		var row   = $(tr);

		// cleanup
		row.find( '.from_date, .from_day_of_week, .from_month, .from_week, .from_time, .from').hide();
		row.find( '.to_date, .to_day_of_week, .to_month, .to_week, .to_time, .to').hide();
		row.find( '.repeating-label' ).hide();
		row.find( '.bookings-datetime-select-to' ).removeClass( 'bookings-datetime-select-both' );
		row.find( '.bookings-datetime-select-from' ).removeClass( 'bookings-datetime-select-both' );
		row.find( '.bookings-to-label-row .bookings-datetimerange-second-label' ).hide();
		row.find( '.rrule' ).hide();


		if ( value == 'custom' ) {
			row.find('.from_date, .to_date').show();
		}
		if ( value == 'custom:daterange' ) {
			row.find('.from_time, .to_time').show();
			row.find('.from_date, .to_date').show();
			row.find( '.bookings-datetime-select-to' ).addClass( 'bookings-datetime-select-both' );
			row.find( '.bookings-datetime-select-from' ).addClass( 'bookings-datetime-select-both' );
			row.find( '.bookings-to-label-row .bookings-datetimerange-second-label' ).show();
		}
		if ( value == 'months' ) {
			row.find('.from_month, .to_month').show();
		}
		if ( value == 'weeks' ) {
			row.find('.from_week, .to_week').show();
		}
		if ( value == 'days' ) {
			row.find('.from_day_of_week, .to_day_of_week').show();
		}
		if ( value.match( "^time" ) ) {
			row.find('.from_time, .to_time').show();
			// Show the date range as well if "time range for custom dates" is selected
			if ( 'time:range' === value ) {
				row.find('.from_date, .to_date').show();
				row.find( '.repeating-label' ).show();
				row.find( '.bookings-datetime-select-to' ).addClass( 'bookings-datetime-select-both' );
				row.find( '.bookings-datetime-select-from' ).addClass( 'bookings-datetime-select-both' );
				row.find( '.bookings-to-label-row .bookings-datetimerange-second-label' ).show();
			}
		}
		if ( value == 'persons' || value == 'duration' || value == 'blocks' ) {
			row.find('.from, .to').show();
		}
		if ( value === 'rrule') {
			row.find( '.rrule' ).show();
		}

		$( '#availability_rows tr' ).show();
	});

	/**
	 * Sanitizes the start and end dates when datepicker value
	 * is set through on onSelect.
	 *
	 * If date comparison fails, it sets both the start and end dates
	 * to the same date.
	 *
	 * @param {object} ref Reference to the input HTML DOM element.
	 */
	function startEndDateSanitizer( ref ) {
		const input = $( ref );
		const dateType = input.closest( 'div' ).attr( 'class' );
		const todaysDate = new Date();
		let startDate, endDate = null;
		let inputComplement = null;

		switch ( dateType ) {
			case 'from_date':
				inputComplement = input.closest( 'tr' ).find( '.to_date .date-picker' );
				startDate = input.datepicker( 'getDate' );
				endDate = inputComplement.datepicker( 'getDate' );

				if ( startDate < todaysDate ) {
					input.datepicker( 'setDate', todaysDate );
				} else if ( endDate && startDate > endDate ) {
					inputComplement.datepicker( 'setDate', startDate );
				}

				break;

			case 'to_date':
				inputComplement = input.closest( 'tr' ).find( '.from_date .date-picker' );
				endDate = input.datepicker( 'getDate' );
				startDate = inputComplement.datepicker( 'getDate' );

				if ( endDate < startDate ) {
					input.datepicker( 'setDate', startDate );
				}

				break;

			default:
				break;
		}
	}

	$( document ).ready( function() {
		// Destroy all instances of date picker under availability rows.
		$( '#availability_rows .date-picker, #pricing_rows .date-picker, #rates_rows .date-picker' ).datepicker( 'destroy' );

		initializeDatepickers();
	} );

	$( 'body' ).on( 'row_added', function() {
		$( '.wc_booking_availability_type select, .wc_booking_pricing_type select' ).trigger( 'change' );

		initializeDatepickers();
	} );

	/**
	 * Initializes datepickers throughout bookings.
	 */
	function initializeDatepickers() {
		$( '#availability_rows .date-picker, #pricing_rows .date-picker, #rates_rows .date-picker, .booking_start_date_field' ).datepicker( {
			dateFormat: 'yy-mm-dd',
			numberOfMonths: 1,
			showButtonPanel: true,
			showOn: 'button',
			buttonImage: wc_bookings_admin_js_params.calendar_image,
			buttonImageOnly: true,
			minDate: 0,
			firstDay: parseInt( wc_bookings_admin_js_params.start_of_week ),
			onSelect: function() {
				startEndDateSanitizer( this );
			},
			beforeShow: function( input ) {
				if ( $( input ).parent().hasClass( 'to_date' ) ) {
					const from_date = $( input ).closest( 'tr' ).find( '.from_date .date-picker' ).datepicker( 'getDate' );
					return { 'minDate': from_date };
				} else {
					return { 'minDate': 0 };
				}
			}
		} );
	}

	$( document ).on( 'change', '#availability_rows .date-picker, #pricing_rows .date-picker', function() {
		startEndDateSanitizer( this );
	} );

	$('body').on( 'woocommerce-product-type-change', function( event, type ) {
		if ( type !== 'booking' ) {
			$('#_wc_booking_has_persons').prop( 'checked', false );
			$('#_wc_booking_has_resources').prop( 'checked', false );
		}
		wc_bookings_trigger_change_events();
	});

	function wc_bookings_trigger_change_events() {
		$('.wc_booking_availability_type select, .wc_booking_pricing_type select, #_wc_booking_duration_type, #_wc_booking_user_can_cancel, #_wc_booking_duration_unit, #_wc_booking_has_persons, #_wc_booking_has_resources, #_wc_booking_has_person_types, #_wc_booking_has_restricted_days').trigger( 'change' );
	}

	$( 'input#_virtual' ).on( 'change', function () {
		wc_bookings_trigger_change_events();
	});

	$('#_wc_booking_duration_type').on( 'change', function() {
		if ( $(this).val() == 'customer' ) {
			$( '#min_max_duration' ).show();
		} else {
			$( '#min_max_duration' ).hide();
		}
	});

	// limit hourly duration up to 24.
	$( '#_wc_booking_duration, #_wc_booking_duration_unit, #_wc_booking_default_date_availability' ).on( 'change', function() {
		limit_hourly_duration( $(this) );
	} );

	$( '#_wc_booking_duration_unit' ).on( 'change', function() {
		$('.availability_time, ._wc_booking_first_block_time_field').hide();
		$( '#enable-range-picker' ).hide();
		$( '._wc_booking_apply_adjacent_buffer_field' ).show();
		$( '._wc_booking_buffer_period' ).show();

		switch ( $( this ).val() ) {
			case 'hour':
			case 'minute':
				var unit_text = 'hour' === $( this ).val() ? wc_bookings_admin_js_params.i18n_hours : wc_bookings_admin_js_params.i18n_minutes;

				$( '._wc_booking_buffer_period_unit' ).text( unit_text );
				$('.availability_time, ._wc_booking_first_block_time_field').show();
				break;
			case 'month':
				$( '#enable-range-picker' ).show();
				$( '._wc_booking_buffer_period' ).hide();
				$( '._wc_booking_apply_adjacent_buffer_field' ).hide();
				break;
			default: //day
				$( '#enable-range-picker' ).show();
				$( '._wc_booking_buffer_period_unit' ).text( wc_bookings_admin_js_params.i18n_days );
				break;
		}
	});

	$( '#_wc_booking_user_can_cancel' ).on( 'change', function() {
		if ( $(this).is( ':checked' ) ) {
			$( '.form-field.booking-cancel-limit' ).show();
		} else {
			$( '.form-field.booking-cancel-limit' ).hide();
		}
	});

	$('#_wc_booking_has_persons').on( 'change', function() {
		if ( $(this).is( ':checked' ) ) {
			$( '#persons-options, .bookings_persons_tab' ).show();
		} else {
			$( '#persons-options, .bookings_persons_tab' ).hide();
		}

		$('ul.wc-tabs li:visible').eq(0).find('a').trigger('click');
	});

	$('#_wc_booking_has_person_types').on( 'change', function() {
		if ( $(this).is( ':checked' ) ) {
			$( '#persons-types' ).show();
		} else {
			$( '#persons-types' ).hide();
		}
	});

	$('#_wc_booking_has_resources').on( 'change', function() {
		if ( $(this).is( ':checked' ) ) {
			$( '.bookings_resources_tab' ).show();
			$( '._wc_booking_qty_field' ).addClass( 'blur' ).attr( 'data-note', wc_bookings_admin_js_params.i18n_max_booking_overwridden );
		} else {
			$( '.bookings_resources_tab' ).hide();
			$( '._wc_booking_qty_field' ).removeClass( 'blur' );
		}

		$('ul.wc-tabs li:visible').eq(0).find('a').trigger('click');
	});

	$('#_wc_booking_has_restricted_days').on( 'change', function() {
		if ( $(this).is( ':checked' ) ) {
			$( '.booking-day-restriction' ).show();
		} else {
			$( '.booking-day-restriction' ).hide();
		}
	});

	wc_bookings_trigger_change_events();

	$('#availability_rows, #pricing_rows').sortable({
		items:'tr',
		cursor:'move',
		axis:'y',
		handle: '.sort',
		scrollSensitivity:40,
		forcePlaceholderSize: true,
		helper: 'clone',
		opacity: 0.65,
		placeholder: 'wc-metabox-sortable-placeholder',
		start:function(event,ui){
			ui.item.css('background-color','#f6f6f6');
		},
		stop:function(event,ui){
			ui.item.removeAttr('style');
			ui.item.show();

			// loop through each of the rows
			jQuery( event.target).find( 'tr' ).each( function ( rowIndex, item ) {

				// update all the form field indexes in the current moved tr
				var fields = jQuery(item).find( '[name*="wc_booking"]' );
				for ( var i=0 ; i < fields.length ; i++  ) {
					var field = fields[ i ];
					var oldName = jQuery( field ).attr( 'name' );
					var newName = oldName.replace( /[\d+]/g, rowIndex);
					if( newName !== oldName ){
						jQuery( field ).attr( 'name', newName );
					}
				}
			});
		}
	});

	$( '.add_row' ).on( 'click', function( e ){
		var indexField = $(e.target).closest('table').find( '#pricing_rows tr:last [name*=wc_booking_pricing_type]' ).attr( 'name' );
		var newRowIndex = indexField ? parseInt( indexField.replace( /[^\[]+\[(.*)\]/, '$1' ) ) + 1 : 0;
		var newRow = $( this ).data( 'row' );
		newRow = newRow.replace( /bookings_cost_js_index_replace/ig, newRowIndex.toString() );
		// Clear out IDs.
		newRow = newRow.replace( /wc_booking_availability_id.+/, 'wc_booking_availability_id[]" value="" />' );
		newRow = newRow.replace( /data-id=.+/, 'data-id="">' );

		// Clear out title.
		newRow = newRow.replace( /wc_booking_availability_title.+/, 'wc_booking_availability_title[]" value="" style="border:1px solid #ddd;background-color:#fff;" />' );

		// Clear out priority.
		newRow = newRow.replace( /wc_booking_availability_priority.+/, 'wc_booking_availability_priority[]" value="10" placeholder="10" />' );

		var tableBody = $(this).closest('table').find('tbody');
		tableBody.append( newRow );
		$('body').trigger('row_added', tableBody.find('tr:last') );

		return false;
	} );

	$( 'body' ).on( 'click', 'td.remove', function() {
		var row = $( this ).parent( 'tr' ),
			id  = row.data( 'id' );

		// Get current deleted list.
		var deleted = $( '.wc-booking-availability-deleted' ).val();

		// Add to deleted list.
		deleted = deleted + ',' + id;
		$( '.wc-booking-availability-deleted' ).val( deleted );

		row.remove();
	});

	$('#bookings_persons').on('change', 'input.person_name', function(){
		$(this).closest('.woocommerce_booking_person').find('span.person_name').text( $(this).val() );
	});

	// limit hourly duration up to 24.
	function limit_hourly_duration( _this ) {
		const booking_duration = $( '#_wc_booking_duration' );
		if ( 'hour' === $( '#_wc_booking_duration_unit' ).val() && 24 < booking_duration.val() && 'non-available' === $( '#_wc_booking_default_date_availability' ).val() ) {
			_this.parents( '.form-field' ).addClass( 'limited-hours' );

			let limited_hours_notice =
				_this.parents( '._wc_booking_default_date_availability_field' ).length !== 0
				? wc_bookings_admin_js_params.i18n_limited_hours_in_gen_tab
				: wc_bookings_admin_js_params.i18n_limited_hours;

			_this.parents( '.form-field' ).addClass( 'limited-hours' ).attr( 'data-note', limited_hours_notice );

			booking_duration.val( 24 );
		} else {
			$( '.form-field' ).removeClass( 'limited-hours' );
		}
	}

	// Add a person type
	jQuery('#bookings_persons').on('click', 'button.add_person', function(){
		jQuery('.woocommerce_bookable_persons').block({ message: null });

		var loop = jQuery('.woocommerce_booking_person').length;

		var data = {
			action:   'woocommerce_add_bookable_person',
			post_id:  wc_bookings_admin_js_params.post,
			loop:     loop,
			security: wc_bookings_admin_js_params.nonce_add_person
		};

		jQuery.post( wc_bookings_admin_js_params.ajax_url, data, function( response ) {
			jQuery('.woocommerce_bookable_persons').append( response ).unblock();
			jQuery('.woocommerce_bookable_persons #message').hide();
			$( '.woocommerce_bookable_persons' ).sortable( persons_sortable_options );
			// Trigger change to set max attribute.
			$('#_wc_booking_max_persons_group').trigger('change');
		});

		return false;
	});

	// Remove a person type
	jQuery('#bookings_persons').on('click', 'button.unlink_booking_person', function(e){
		e.preventDefault();
		var answer = confirm( wc_bookings_admin_js_params.i18n_remove_person );
		if ( answer ) {

			var el = jQuery(this).parent().parent();

			var person = jQuery(this).attr('rel');

			if ( person > 0 ) {

				jQuery(el).block({ message: null });

				var data = {
					action:    'woocommerce_unlink_bookable_person',
					person_id: person,
					security:  wc_bookings_admin_js_params.nonce_unlink_person
				};

				jQuery.post( wc_bookings_admin_js_params.ajax_url, data, function( response ) {
					jQuery(el).fadeOut('300', function(){
						jQuery(el).remove();
					});
				});

			} else {
				jQuery(el).fadeOut('300', function(){
					jQuery(el).remove();
				});
			}

		}
		return false;
	});

	var persons_sortable_options = {
		items: '.woocommerce_booking_person',
		cursor: 'move',
		axis: 'y',
		handle: 'h3',
		scrollSensitivity: 40,
		forcePlaceholderSize: true,
		helper: 'clone',
		opacity: 0.65,
		placeholder: 'wc-metabox-sortable-placeholder',
		start: function( event, ui ) {
			ui.item.css( 'background-color', '#f6f6f6' );
		},
		stop: function ( event, ui ) {
			ui.item.removeAttr( 'style' );
			person_row_indexes();
		}
	};

	$( '.woocommerce_bookable_persons' ).sortable( persons_sortable_options );

	function person_row_indexes() {
		$('.woocommerce_bookable_persons .woocommerce_booking_person').each(function(index, el){
			$('.person_menu_order', el).val( parseInt( $(el).index('.woocommerce_bookable_persons .woocommerce_booking_person'), 10 ) );
		});
	};

	$('#bookings_resources').on('change', 'input.resource_name', function(){
		$(this).closest('.woocommerce_booking_resource').find('span.resource_name').text( $(this).val() );
	});

	// Add a resource
	jQuery('#bookings_resources').on('click', 'button.add_resource', function(){
		var loop              = jQuery('.woocommerce_booking_resource').length;
		var add_resource_id   = jQuery('select.add_resource_id').val();
		var add_resource_name = '';

		if ( ! add_resource_id ) {
			add_resource_name = prompt( wc_bookings_admin_js_params.i18n_new_resource_name );

			if ( ! add_resource_name ) {
				return false;
			}
		}

		jQuery( '.woocommerce_bookable_resources' ).block( { message: null } );

		var data = {
			action:            'woocommerce_add_bookable_resource',
			post_id:           wc_bookings_admin_js_params.post,
			loop:              loop,
			add_resource_id:   add_resource_id,
			add_resource_name: add_resource_name,
			security:          wc_bookings_admin_js_params.nonce_add_resource
		};

		jQuery.post( wc_bookings_admin_js_params.ajax_url, data, function( response ) {
			if ( response.error ) {
				alert( response.error );
			} else {
				jQuery( '.woocommerce_bookable_resources' ).append( response.html ).unblock();
				jQuery( '.woocommerce_bookable_resources' ).sortable( resources_sortable_options );
				if ( add_resource_id ) {
					jQuery( '.add_resource_id' ).find( 'option[value=' + add_resource_id + ']' ).remove();
				}
			}
		});

		return false;
	});

	// Remove a resource
	jQuery('#bookings_resources').on('click', 'button.remove_booking_resource', function(e){
		e.preventDefault();
		var answer = confirm( wc_bookings_admin_js_params.i18n_remove_resource );
		if ( answer ) {

			var el       = jQuery(this).parent().parent();
			var resource = jQuery(this).attr('rel');

			jQuery(el).block({ message: null, overlayCSS: { background: '#fff url(' + wc_bookings_admin_js_params.plugin_url + '/assets/images/ajax-loader.gif) no-repeat center', opacity: 0.6 } });

			var data = {
				action:      'woocommerce_remove_bookable_resource',
				post_id:     wc_bookings_admin_js_params.post,
				resource_id: resource,
				security:    wc_bookings_admin_js_params.nonce_delete_resource
			};

			jQuery.post( wc_bookings_admin_js_params.ajax_url, data, function( response ) {
				jQuery(el).fadeOut('300', function(){
					jQuery(el).remove();
					var resource_id = jQuery(el).find('input[name*=resource_id]').val();
					var resource_title = jQuery(el).find('input[name*=resource_title]').val();
					jQuery('select[name=add_resource_id]').append( jQuery('<option>', {
						    value: resource_id,
						    text: resource_title
					}));
				});
			});
		}
		return false;
	});

	var resources_sortable_options = {
		items: '.woocommerce_booking_resource',
		cursor: 'move',
		axis: 'y',
		handle: 'h3',
		scrollSensitivity: 40,
		forcePlaceholderSize: true,
		helper: 'clone',
		opacity: 0.65,
		placeholder: 'wc-metabox-sortable-placeholder',
		start: function( event, ui ) {
			ui.item.css( 'background-color', '#f6f6f6' );
		},
		stop: function ( event, ui ) {
			ui.item.removeAttr( 'style' );
			resource_row_indexes();
		}
	};

	$( '.woocommerce_bookable_resources' ).sortable( resources_sortable_options );

	function resource_row_indexes() {
		$('.woocommerce_bookable_resources .woocommerce_booking_resource').each(function(index, el){
			$('.resource_menu_order', el).val( parseInt( $(el).index('.woocommerce_bookable_resources .woocommerce_booking_resource'), 10 ) );
		});
	}

	// Set max attribute for the max persons field in person types.
	$('#bookings_persons').on('change', '#_wc_booking_max_persons_group', function(){
		const max_persons_group = $(this).val();
		if( max_persons_group && max_persons_group > 0 ) {
			$('.woocommerce_bookable_persons').find('input.person_max, input.person_min').each(function(){
				$(this).attr('max', max_persons_group);
			});
		} else {
			$('.woocommerce_bookable_persons').find('input.person_max, input.person_min').each(function(){
				$(this).removeAttr('max');
			});
		}
	});
	// Trigger change to set max attribute values of max for person types.
	$('#_wc_booking_max_persons_group').trigger('change');

	// Render the WordPress timepicker for the time input field inside "from_time" container.
	// This is needed for the initial load.
	// The timepicker is not rendered for the "google-event" rows.
	document.querySelectorAll(
		[
			'#availability_rows tr:not(.google-event) .from_time',
			'#availability_rows tr:not(.google-event) .to_time',
			'#pricing_rows .from_time',
			'#pricing_rows .to_time',

		].join( ', ' )
	).forEach( ( el ) => {
		renderWPTimePicker( el );
	} );

	// Render the WordPress timepicker for the time input field inside "from_time" container when a new row is added.
	$( 'body' ).on( 'row_added', function ( e, jQueryRowSelector ) {
		// Do not render the timepicker for the "google-event" rows.
		if( jQueryRowSelector.classList.contains('google-event') ){
			return;
		}

		if( jQueryRowSelector.closest( '#availability_rows' ) || jQueryRowSelector.closest( '#pricing_rows' ) ) {
			jQueryRowSelector.querySelectorAll( '.from_time, .to_time' )
				.forEach( ( el ) => {
					renderWPTimePicker( el );
				}
			);
		}
	} );

	/**
	 * Should render the WordPress timepicker.
	 *
	 * @since 1.16.0
	 * @param {HTMLElement} el The time input field container. div.from_time or div.to_time.
	 *
	 * @return {void}
	 */
	function renderWPTimePicker( el ) {
		const timeElement = el.querySelector( 'input[type="time"]' );
		const timeIn24Hours = timeElement.value ?
			timeElement.value.split( ':' ) : // Saved time
			['00', '00']; // Default time.
		const currentTime = new Date();

		// Edit current time to set the time (hours, minutes) from the time input field.
		currentTime.setHours( timeIn24Hours[0] );
		currentTime.setMinutes( timeIn24Hours[1] );

		// This function handles WP Timpicker change event to update the hidden input field with the time.
		let setTimeAsValueToInputField = ( timeFieldContainer, time ) => {
			const date = new Date( time );
			const hours = date.getHours().toString().padStart( 2, '0' );
			const minutes = date.getMinutes().toString().padStart( 2, '0' );

			// Update the hidden input field.
			timeFieldContainer.querySelector( 'input:last-child' ).value = `${hours}:${minutes}`;
		};
		setTimeAsValueToInputField = setTimeAsValueToInputField.bind( null, el );

		// Replace time input with TimePicker.
		wpElementRenderer(
			(
				<TimePicker
					currentTime={currentTime}
					is12Hour={'1' === wc_bookings_admin_js_params.time_in_12hours}
					onChange={setTimeAsValueToInputField}
					__nextRemoveHelpButton
					__nextRemoveResetButton
				/>
			),
			el
		);

		// Add hidden input to store the time value.
		el.insertAdjacentHTML(
			'beforeend',
			`<input type="hidden" name="${timeElement.name}" value="${timeElement.value}" />`
		);
	}
});
